/**
 * Hook chamado UMA vez pelo app-core: liga a busca dos focos ao loop
 * (sync.ts) e o filtro por áreas (areaSync.ts), e adiciona ao mapa a camada
 * de focos e o destaque das áreas do filtro quando o mapa existir.
 */
import { useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { createAreaFocusLayer } from './areaFocusLayer';
import { startAreaSync } from './areaSync';
import { createFireLayer } from './layer';
import { startFireSync } from './sync';

export { refreshFires } from './sync';

export function useFireLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => startFireSync(), []);
  useEffect(() => startAreaSync(), []);

  useEffect(() => {
    if (!map) return;
    const { layer, dispose } = createFireLayer();
    const focus = createAreaFocusLayer();
    map.addLayer(focus.layer);
    map.addLayer(layer);
    return () => {
      map.removeLayer(layer);
      map.removeLayer(focus.layer);
      dispose();
      focus.dispose();
    };
  }, [map]);
}
